export default "__VITE_ASSET__Bq1r9xA8__"